import { createClient } from '@supabase/supabase-js';

// ─────────────────────────────────────────────────────────────────
// Your Supabase credentials come from environment variables.
//
// Local dev:  create .env.local in the project root:
//   REACT_APP_SUPABASE_URL=https://xxxx.supabase.co
//   REACT_APP_SUPABASE_ANON_KEY=sb_publishable_xxxx
//
// Vercel:  add the same two keys under
//   Project → Settings → Environment Variables
// ─────────────────────────────────────────────────────────────────

const SUPABASE_URL      = process.env.REACT_APP_SUPABASE_URL      || '';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  // Only warn — app still renders so you can see the error clearly
  console.warn(
    '[Strategists] Supabase credentials missing.\n' +
    'Create .env.local with:\n' +
    '  REACT_APP_SUPABASE_URL=https://xxxx.supabase.co\n' +
    '  REACT_APP_SUPABASE_ANON_KEY=sb_publishable_xxxx'
  );
}

export const supabase = createClient(
  SUPABASE_URL      || 'https://placeholder.supabase.co',
  SUPABASE_ANON_KEY || 'placeholder',
  // Staff sign in with Supabase Auth; the session (and its refresh) lives in this
  // browser so the database sees a signed-in staff token on every request.
  { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false, storageKey: 'str-auth' } }
);

// Every row is scoped to this organisation ID.
// If you ever add another company, just change this constant.
export const ORG_ID = 'strategists_pk';
